<div *ngIf="(pinnedItems$ | async)?.length > 0" class="business-navbar__sidebar__pinned-items" cdkDropList
    [cdkDropListData]="(pinnedItems$ | async)" (cdkDropListDropped)="onDrop($event)">
    <div *ngFor="let item of (pinnedItems$ | async)"
         cdkDrag [cdkDragData]="item" cdkDragLockAxis="y" [cdkDragDisabled]="disablePinning$ | async"
        (mousedown)="onMouseDown($event)" class="business-navbar__sidebar__nav-item">

        <atlas-nav-item
            [url]="item.url"
            [path]="item.path"
            [icon]="item.icon"
            [label]="item.label"
            [translationId]="item.translationId"
            [logoUrl]="item.logoUrl"
            [serviceProviderId]="item.serviceProviderId"
            [pinnable]="false"
            [ooProduct]="item.ooProduct"
            [productNavigation]="true"
            [navigationId]="item.navigationId"
            [showIcon]="item.showIcon"
            [userRequired]="item.userRequired"
            class="business-navbar__sidebar__nav-item"
        >
            <atlas-icon cdkDragHandle *ngIf="!(disablePinning$ | async)" class="business-navbar__sidebar__drag_handle"
                        matIcon="drag_handle"></atlas-icon>
        </atlas-nav-item>
    </div>
</div>
